import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';
import AnchorLink from 'components/common/AnchorLink';
import Breadcrumb from 'components/common/Breadcrumb';
import AboutDetail from './AboutDetail';
import AboutClients from './AboutClients';
import List from './List';
import './About.css';
import MyHelmet from 'components/common/MyHelmet';

const About = (props) => {
	return (
		<div id="Page_About" className="Page">
			<MyHelmet
				title="About us"
			/>{/* TODO: BAD */}
			
			<div className="wrap">
				<Breadcrumb items={props.breadcrumb} />
			</div>

			<div id="About-body">
				{ props.contact && 
					<section id="About-detail">
						<div className="wrap">
							<AboutDetail contact={props.contact} />
						</div>
					</section>
				}

				{ props.clients && 
					<section id="About-clients" className="About-section">
						<div className="wrap">
							<h4>Clients</h4>
							<AboutClients list={props.clients} />
						</div>
					</section>
				}

				{ props.awards && 
					<section id="About-awards" className="About-section">
						<div className="wrap">
							<h4>Awards</h4>
							<List text={props.awards} />
						</div>
					</section>
				}
				
				{ props.exhibitions &&
					<section id="About-exhibitions" className="About-section">
						<div className="wrap">
							<h4>Exhibitions</h4>
							<List text={props.exhibitions} />
						</div>
					</section>
				}

				{ props.press && 
					<section id="About-press" className="About-section">
						<div className="wrap">
							<h4>Press</h4>
							<List text={props.press} />
						</div>
					</section>
				}
			</div>

			{ (props.contact || props.clients || props.awards || props.exhibitions || props.press) &&
				<div className="wrap">
					<AnchorLink className="btnBacktoTop" href="#Page_About"><span>Back to Top ↑</span></AnchorLink>
				</div>
			}
		</div>
	)
}
About.propTypes = {
	contact: PropTypes.string,
	clients: PropTypes.array,
	awards: PropTypes.string,
	exhibitions: PropTypes.string,
	press: PropTypes.string,
	breadcrumb: PropTypes.array,
}
const mapStateToProps = (state) => {
	const about       = get(state.fetcher, ['page', 'about', 'data', 'about'], {});
	const clients     = get(state.fetcher, ['page', 'about', 'data', 'clients']);
	const contact     = about.contactInformation;
	const awards      = about.awards;
	const exhibitions = about.exhibitions;
	const press       = about.press;
	
	return {
		clients: clients,
		contact: contact,
		awards: awards,
		exhibitions: exhibitions,
		press: press,
		breadcrumb: [{title: 'About'}]
	};
}
export default connect(mapStateToProps)(About);


// WEBPACK FOOTER //
// ./src/components/Pages/About/About.jsx